/**
 * Upsell no carrinho lateral: adicionar complemento ou trocar pela Duplinha.
 */
(function () {
  const LOADING_CLASS = 'cart-drawer-upsell--loading';
  const BUTTON_LOADING_CLASS = 'cart-drawer-upsell__button--loading';

  function setButtonLoading(button, isLoading) {
    if (!button) return;

    button.disabled = isLoading;
    button.setAttribute('aria-busy', isLoading ? 'true' : 'false');

    button.classList.toggle(BUTTON_LOADING_CLASS, isLoading);

    const label = button.querySelector('.cart-drawer-upsell__button-label');
    const loading = button.querySelector('.cart-drawer-upsell__button-loading');

    label?.classList.toggle('hidden', isLoading);
    loading?.classList.toggle('hidden', !isLoading);
    if (loading) loading.setAttribute('aria-hidden', isLoading ? 'false' : 'true');
  }

  function getCartDrawer() {
    return document.querySelector('cart-drawer');
  }

  function getSectionIds() {
    const cartDrawer = getCartDrawer();
    if (cartDrawer?.getSectionsToRender) {
      return cartDrawer.getSectionsToRender().map((section) => section.id);
    }
    return ['cart-drawer', 'cart-icon-bubble'];
  }

  async function addVariant(variantId, quantity = 1, includeSections = true) {
    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', quantity);

    if (includeSections) {
      formData.append('sections', getSectionIds().join(','));
      formData.append('sections_url', window.location.pathname);
    }

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    config.body = formData;

    const response = await fetch(`${routes.cart_add_url}`, config);
    return response.json();
  }

  async function zeroVariants(variantIds) {
    const updates = {};
    variantIds.forEach((id) => {
      updates[String(id)] = 0;
    });

    const response = await fetch(`${routes.cart_update_url}`, {
      ...fetchConfig(),
      body: JSON.stringify({ updates }),
    });

    return response.json();
  }

  async function refreshCartDrawer() {
    const cartDrawerItems = document.querySelector('cart-drawer-items');
    if (cartDrawerItems?.onCartUpdate) {
      await cartDrawerItems.onCartUpdate();
      return;
    }

    const response = await fetch(`${routes.cart_url}?section_id=cart-drawer`);
    const html = await response.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const sourceInner = doc.querySelector('.drawer__inner');
    const targetInner = document.querySelector('cart-drawer .drawer__inner');

    if (sourceInner && targetInner) {
      targetInner.innerHTML = sourceInner.innerHTML;
    }

    const cartDrawer = getCartDrawer();
    const isEmpty = !doc.querySelector('cart-drawer-items .cart-item');
    if (cartDrawer) {
      cartDrawer.classList.toggle('is-empty', isEmpty);
    }
  }

  function renderCartDrawer(response) {
    const cartDrawer = getCartDrawer();
    if (!cartDrawer?.renderContents || !response?.sections) {
      return refreshCartDrawer();
    }

    cartDrawer.classList.remove('is-empty');
    return cartDrawer.renderContents(response);
  }

  async function handleUpsellAction(button) {
    const action = button.dataset.cartUpsellAction;
    const variantId = button.dataset.variantId;
    const removeVariantsRaw = button.dataset.removeVariants;
    const upsellRoot = button.closest('[data-cart-drawer-upsell]');

    if (!variantId || button.classList.contains(BUTTON_LOADING_CLASS)) return;

    setButtonLoading(button, true);
    upsellRoot?.classList.add(LOADING_CLASS);

    try {
      if (action === 'swap' && removeVariantsRaw) {
        const variantIds = removeVariantsRaw
          .split(',')
          .map((id) => id.trim())
          .filter(Boolean);

        // Adiciona a Duplinha antes de remover — evita carrinho vazio se o add falhar
        const addResponse = await addVariant(variantId, 1, false);

        if (addResponse.status) {
          throw new Error(addResponse.description || addResponse.message);
        }

        if (variantIds.length) {
          await zeroVariants(variantIds);
        }

        await refreshCartDrawer();
      } else if (action === 'add') {
        const addResponse = await addVariant(variantId, 1, true);

        if (addResponse.status) {
          throw new Error(addResponse.description || addResponse.message);
        }

        await renderCartDrawer(addResponse);
      } else {
        await refreshCartDrawer();
      }
    } catch (error) {
      console.error('Erro no upsell do carrinho:', error);
      await refreshCartDrawer();
    } finally {
      upsellRoot?.classList.remove(LOADING_CLASS);
      if (button.isConnected) setButtonLoading(button, false);
    }
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-cart-upsell-action]');
    if (!button) return;

    event.preventDefault();
    handleUpsellAction(button);
  });
})();
